import React, { FC } from 'react';

import { Button, PopUp } from 'application/components';

import { SuccessModalProps } from './models';
import { ModalStyled } from './styles';

const SuccessModal: FC<SuccessModalProps> = ({ opened, onSubmit }) => {
  return (
    <PopUp opened={opened} title="Thank you">
      <ModalStyled>
        <p>
          Your commitment received! Continue the investment process in the app.
        </p>
        <Button type="button" onClick={onSubmit}>
          Back to Deal
        </Button>
      </ModalStyled>
    </PopUp>
  );
};

export default SuccessModal;
